import { useState, useEffect } from "react";
import { BtnComponent } from '../../components/button';

// import { Icon } from "helpers/icons";
import ActionMenuList from "../ActionMenuList";

export const AppListing = (props) => {
  const { styleForBody,showColorCode } = props;
  // props?.enableSearch @BOOLEAN true/false -> TO add search text box on TOP for filtering result
  // props?.searchKey @STRING KEY_NAME -> default is title on which you like to search
  const [allSelected, setSelectedAll] = useState(false);
  const [listData, setListData] = useState([]);
  const [rowClass, setRowClass] = useState("");
  const [searchField, setSearchField] = useState("");
  const searchOnKey = props?.searchKey ?? "title";
  const enableSearch = props?.enableSearch ?? false;
  const enableUISearch = props?.enableUISearch ?? false;
  const uiSearchText = props?.uiSearchText ?? '';
  const uiSearchKey = props?.uiSearchKey ?? false;

  useEffect(() => {
    if (props?.listData) {
      if (props?.selection) {
        let list = [];
        props?.listData.map((item) => {
          let selected = false;
          if (props?.selectedDocs) {
            const docFound = props?.selectedDocs?.find(
              (selectedDoc) => selectedDoc?.id == item?.id
            );
            selected = docFound ? true : false;
          }
          list.push({ selected: selected, ...item });
        });
        setListData(list);
      } else {
        setListData([...props?.listData]);
      }
    }
    setContainers();
  }, [props?.selection, props?.listData]);
  const displayValue = (item, col,colIndex) => {
    let txt;
    if (col?.getData) {
      txt = col?.getData(item,colIndex);
    } else if (col?.key) {
      txt = item[col?.key];
    }
    return txt || "";
  };
  const toggleSelectItem = (item, itemIndex, e) => {
    const selected = e.target.checked;
    item.selected = selected;
    listData[itemIndex] = item;
    setListData([...listData]);
    const unselected = listData.find((item) => {
      return !item?.selected;
    });
    const all = unselected ? false : true;
    setSelectedAll(all);
    if (props?.toggleSelectItem) {
      const selectedItems = listData.filter((item) => item?.selected);
      props?.toggleSelectItem(selectedItems);
    }
  };
  const toggleSelectAll = (e) => {
    const checkedAll = e.target.checked;
    listData.map((item) => {
      item.selected = checkedAll;
    });
    setSelectedAll(checkedAll);
    if (props?.toggleSelectAll) {
      props?.toggleSelectAll(e);
    }
    const selectedItems = checkedAll ? listData : [];
    if (props?.toggleSelectItem) {
      props?.toggleSelectItem(selectedItems);
    }
    if (props?.toggleSelectItem) {
      props?.toggleSelectItem(selectedItems);
    }
  };
  const returnSelectedItems = () => {
    if (props && props?.selectItems) {
      const selectedItems = listData.filter((item) => item?.selected);
      props?.selectItems(selectedItems);
    }
  };
  const closeListingView = () => {
    setListData([...props?.listData]);
    setSelectedAll(false);
    if (props && props?.cancel) {
      props?.cancel();
    }
  };
  const rowClick = (e, item, itemIndex) => {
    if (props?.rowClick) {
      e.stopPropagation();
      e.preventDefault();
      props?.rowClick(item, itemIndex);
    }
  };
  function setContainers() {
    let css = "";
    let pl = "pl-2.5",
      pr = "pr-2.5",
      py = "py-1.5",
      relative = "";
    if (props?.selection) {
      pl = "pl-7";
      css += " has-selection";
      relative = "relative";
    }
    if (props?.actions && props?.actions.length) {
      pr = "pr-7";
      css += " has-actions";
      relative = "relative";
    }
    css += " " + pl + " " + pr + " " + py + " " + relative;
    setRowClass(css);
  }
  const searchableField = () => {
    if (enableSearch) {
      return (
        <div className="outline relative border border-black-opaciety-28 bg-white focus-within:border-teal-c-900 outlineStyle rounded-xs">
          <input
            type="text"
            name="filterResult"
            className="block p-2 w-full appearance-none z-10 relative rounded-lg focus:outline-none bg-transparent focus:ring-0 font-light text-base text-gray-c-400 placeholder-gray-500"
            onChange={(e) => setSearchField(e.target.value)}
          />

          <label
            htmlFor="filterResult"
            className="absolute top-0 p-3 pl-4  duration-300 origin-0 rounded-lg mr-2 inline-block bg-white px-1 text-xs font-normal"
          >
            Search
          </label>
        </div>
      );
    }
    return "";
  };

  const headerCss = `${props?.displayStyle === 'flex' ? " flex gap-2 " : " grid gap-6 grid-cols-12 "}  ${
    props?.headerType == "simple"
      ? "app-listing-header-simple"
      : "app-listing-header"
  }`;
  const bodyCss = `${props?.displayStyle === 'flex' ? " flex gap-2 " : " grid gap-6 grid-cols-12 "} app-listing-row`;
  const checkboxCss =
    "w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600";
  const displayHeaders =
    typeof props?.displayHeader != "undefined" ? props?.displayHeader : true; // Always display Header Title
  return (
    <div className="text-left">
      {displayHeaders && (
        <div className={headerCss + " "  + "  p-2"}>
          {props?.cols?.map((col, colIndex) => {
            return (
              <div
                key={col?.key + colIndex}
                className={
                  props?.displayStyle === 'flex' ? col?.colWidth :
                  ("col-span-" +
                  (col?.colWidth || "3") +
                  " sm:col-span-" +
                  (col?.colWidth || "3")) +" text-left"
                }
              >
                {props?.selection && colIndex == 0 ? (
                  <span className="mr-2 item-selection">
                    <input
                      id={"col" + colIndex}
                      key={"col" + colIndex}
                      type="checkbox"
                      onChange={(e) => {
                        toggleSelectAll(e);
                      }}
                      checked={allSelected}
                      className={checkboxCss}
                    />
                    {allSelected}
                  </span>
                ) : (
                  ""
                )}
                {col?.title}
                {props?.selection && colIndex == 0 ? (
                  <span className="mr-2"></span>
                ) : (
                  ""
                )}
              </div>
            );
          })}
        </div>
      )}

      {searchableField()}

      <div
        className={` ${
          props?.listContainerCls
            ? " app-list-container-default "
            : " app-list-container " +
              ` ${listData && listData.length && "pb-20"}  `
        }`}
      >
        {listData && listData.length ? (
          listData.map((item, itemIndex) => {
            return (
              (searchField == "" ||
                item[searchOnKey]
                  ?.toLowerCase()
                  .indexOf(searchField.toLowerCase()) > -1) && (
                <>
                  <div
                    key={"item_" + itemIndex}
                    onClick={(e) => {
                      rowClick(e, item, itemIndex);
                    }}
                    className={
                      bodyCss +
                      " " +
                      rowClass +
                      " " +
                      (props?.rowClick && !item?.disable_row ? "cursor-pointer" : "") +
                      ((enableUISearch && uiSearchText.length>2 && item[uiSearchKey]
                        ?.toLowerCase()
                        .indexOf(uiSearchText.toLowerCase()) < 0) ? 'hidden' : '') +
                      ((item?.disable_row) ? ' cursor-not-allowed disable-row' : '') +
                       ((showColorCode && item?.color_code?.toLowerCase()) ? ` bg-${item?.color_code?.toLowerCase()}-300 `: '')

                    }
                  >
                    
                    {props?.cols?.map((col, colIndex) => {
                      return (
                        <div

                          key={"itemval_" + itemIndex + colIndex}
                          className={
                            props?.displayStyle === 'flex' ? col?.colWidth : 
                            ("break-words col-span-" +
                            (col?.colWidth || "3") +
                            " sm:col-span-" +
                            (col?.colWidth || "3"))
                          }
                        >
                          {props?.selection && colIndex == 0 ? (
                            <span className="mr-2 -ml-5 flex ">
                              <label htmlFor={"fields." + itemIndex + colIndex} className="flex">
                                <input
                                  id={"fields." + itemIndex + colIndex}
                                  key={"fields." + itemIndex + colIndex}
                                  type="checkbox"
                                  onChange={(e) => {
                                    toggleSelectItem(item, itemIndex, e);
                                  }}
                                  checked={item?.selected}
                                  className={checkboxCss}
                                />
                              </label>
                              <span className="ml-2">
                                  {displayValue(item, col,itemIndex)}
                                </span>
                            </span>
                          ) : (
                            <div
                              className={col?.styleForLabel}
                              onClick={() => {
                                if (col?.clickOnLabel) {
                                  col?.clickOnLabel(item, col, itemIndex);
                                }
                              }}
                            >
                              {" "}
                              {displayValue(item, col, itemIndex)}
                            </div>
                          )}
                          {!item?.disable_row && (props?.actions &&
                          props?.actions.length &&
                          colIndex + 1 == props?.cols?.length ? (
                            <ListActions
                              actionMenuList={props?.actionMenuList}
                              actions={props?.actions}
                              item={item}
                              itemIndex={itemIndex}
                              col={col}
                            />
                          ) : (
                            ""
                          ))}
                        </div>
                      );
                    })}
                  </div>
                </>
              )
            );
          })
        ) : (
          <div className="grid gap-6 grid-cols-12 app-listing-body p-5">
            <div className="col-span-12 sm:col-span-12 text-center ">
              No Record Found.
            </div>
          </div>
        )}
      </div>
      {props?.selectItems || props?.cancel ? (
        <div className="pt-4 text-right">
          {props?.selectItems ? (
            <BtnComponent
              className="mr-4"
              onClick={returnSelectedItems}
              text={props?.selectText || "Select"}
            />
          ) : (
            ""
          )}
          {props?.cancel ? (
            <BtnComponent
              onClick={closeListingView}
              btnType="default"
              text={props?.cancelText || "Cancel"}
            />
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

const ListActions = (props) => {
  return (
    <>
      {props?.actionMenuList ? (
        (!props?.item?.disable_row && <ActionMenuList
          title="Actions"
          menuList={props?.actions}
          param={props?.item}
        />)
      ) : (
        <>
          {props?.actions.length == 1 ? (
            <div className="list-actions-link">
              <a
                className="cursor-pointer inline-block hover:bg-slate-100 border border-transparent hover:text-gray-800 hover:border-slate-400"
                onClick={() =>
                  props?.actions[0].onClick(
                    props?.item,
                    props?.col,
                    props?.itemIndex
                  )
                }
              >
                {/* <Icon type={props?.actions[0].type} /> */}
              </a>
            </div>
          ) : (
            <></>
            // <Dropdown {...props} />
          )}
        </>
      )}
    </>
  );
};
